import { TagIcon } from "lucide-react";
import { type ReactNode } from "react";

type Props = {
  icon?: ReactNode;
  children: ReactNode;
};

export function Tag({ icon, children }: Props) {
  return (
    <div className="full flex flex-row items-center gap-1 rounded-full border border-info bg-info/10 px-2 py-1 text-info">
      {icon ? icon : <TagIcon size={20} />}
      {children}
    </div>
  );
}
